import '../../assets/css/Principais.css'
import '../../assets/css/fonts.css'
import '../../assets/css/alteraSenha.css'
import '../../assets/css/colors.css'

import { useEffect, useState } from 'react'
import { ResetaSenhaRevendedora } from '../funcionalidades/bancoGet'
import MenuSuperior from '../menuSuperior/MenuSuperior'

var windowHeight = window.screen.availHeight;
//logoAnimation
export default function ResetaSenhaRevend(props){

    const [callAlteraSenha, setCallAlteraSenha] = useState(0)
    const [cliecpfcnpj, setcliecpfcnpj] = useState('')

    const [alerta, setAlerta] = useState({status: false, title: '', text: ''})
    const usu_login = localStorage.getItem('usu_login')

    useEffect(() => {
         if(callAlteraSenha !== 0){
            ResetaSenhaRevendedora({cliecpfcnpj: cliecpfcnpj})
                .then(resp=>{
                    if(resp.Error){
                        setAlerta({status: true, title: "Algo deu errado", text: resp.Error})
                    }else{
                        console.log(resp)
                        setAlerta({status: true, title: "Sucesso", text: "Senha Alterada com sucesso!"})
                    }
                })
                .catch(()=>{setAlerta({status: true, title: "Algo deu errado", text: "Sistema Indisponível!"})})
        }
      }, [callAlteraSenha]);

    return <>
        <div className="containerPrincipal alteraSenha" style={{minHeight: "100vh", display: 'flex',
    flexDirection: 'column', justifyContent: "flex-end", overflowY: "hidden"}}>
        <MenuSuperior />
        {alerta.status  ? <div id="customDialog" className="custom-dialog" style={alerta.status ? {display: 'block'} : {display: 'none'}}>
            <h2>{alerta.title}</h2>
            <p>{alerta.text}</p>
            <button onClick={()=>setAlerta({status: false, title: "", text: ""})}>OK</button>
        </div> : <></>}
            <div className="containerMudaSenha">
                <div className="titleMudaSenha" style={{textAlign: 'center'}}>Resetar Senha Revendedora</div>
                <input type="text"  className="senhaNova" placeholder='Digite o CPF/CNPJ'
                                            onChange={(event)=>setcliecpfcnpj(event.target.value)} value={cliecpfcnpj}/>

                <div className="buttonAlteraSenha" onClick={()=>setCallAlteraSenha(callAlteraSenha+1)}>Resetar Senha</div>
                <div className="buttonCancelMudarSenha" onClick={()=>{window.location.href = '/metavendedoracliente'}}>Cancelar</div>
            </div>
        </div>
    </>
}